import { ContentSwitcherValue } from '../../types';

// filter the displayed items based on the child relations of params
export const getRelatedContent = (
  values: ContentSwitcherValue[],
  activeItems: Record<string, string>,
): ContentSwitcherValue[] => {
  // make a deep copy so that we can modify the array without changing the values prop
  const clonedValues: ContentSwitcherValue[] = JSON.parse(
    JSON.stringify(values),
  );

  Object.entries(activeItems).forEach(([paramKey, paramValue]) => {
    // find the value for the current param
    const value = values.find(({ param }) => paramKey === param);
    // get the item for the current param value
    const item = value?.items.find(({ id }) => id === paramValue);

    if (item?.children) {
      // go through the children object and filter the items in other param
      Object.entries(item.children).forEach(([key, itemsToFilter]) => {
        // find the value where the items need to be filtered
        const index = clonedValues.findIndex(({ param }) => param === key);
        if (index !== -1) {
          // filter the items
          clonedValues[index].items = clonedValues[index].items.filter(
            ({ id }) => itemsToFilter.includes(id),
          );
        }
      });
    }
  });

  return clonedValues.filter(({ param }) =>
    Object.keys(activeItems).includes(param),
  );
};
